import { create } from 'zustand'
import { api } from '@/api/client'
import { useSpaceStore } from './spaceStore'
import type { DiaryEntry } from '@/types/models'

interface DiaryState {
  diaryData: Record<string, DiaryEntry>
  loadDiary: (date: string) => Promise<void>
  saveDiary: (date: string, content: string) => Promise<boolean>
  clearDiary: () => void
}

function getDiaryUrl(date: string): string {
  const { activeSpace, currentSpace } = useSpaceStore.getState()
  if (activeSpace === 'default') return `/api/diary/${date}`
  if (activeSpace.startsWith('space:') && currentSpace) return `/api/spaces/${currentSpace.id}/diary/${date}`
  if (activeSpace === 'vault') return `/api/vault/diary/${date}`
  return `/api/diary/${date}`
}

export const useDiaryStore = create<DiaryState>()((set) => ({
  diaryData: {},

  clearDiary: () => set({ diaryData: {} }),

  loadDiary: async (date) => {
    try {
      const url = getDiaryUrl(date)
      const data = await api.get<DiaryEntry>(url)
      if (data && data.content !== undefined) {
        set(s => ({ diaryData: { ...s.diaryData, [date]: data } }))
      }
    } catch {
      // no diary for this date
    }
  },

  saveDiary: async (date, content) => {
    try {
      const url = getDiaryUrl(date)
      await api.put(url, { content })
      set(s => ({
        diaryData: {
          ...s.diaryData,
          [date]: { date, content, updatedAt: new Date().toISOString() },
        },
      }))
      return true
    } catch (e) {
      throw e
    }
  },
}))
